import { useEffect, useState } from 'react';
import { Box, Heading, Icon, Tag, Text, TextButton, Upsell } from '@zillow/constellation-10';
import { IconChecklistFilled } from '@zillow/constellation-icons';
import { ApplicationShare } from '../ApplicationShare/ApplicationShare';
import type { UserStatus } from '../../graphql/queries';
import { useRouter } from 'next/router';
import {
  emitShareApplicationUpsellClickEvent,
  emitShareApplicationUpsellImpressionEvent,
} from '../../analytics/clickstreamEvents';
import { useApplicationContextOrUndefined } from '../../contexts/ApplicationContext';

export function ApplicationShareUpsell({ userStatuses }: { userStatuses: Array<UserStatus> }) {
  const router = useRouter();
  const applicationContext = useApplicationContextOrUndefined();
  const { shareAddress, unit, ...queryWithoutShareAddress } = router.query;
  const [isShareModalOpen, setIsShareModalOpen] = useState(!!shareAddress);

  function onClickShare() {
    setIsShareModalOpen(true);
    emitShareApplicationUpsellClickEvent(applicationContext);
  }

  useEffect(() => {
    emitShareApplicationUpsellImpressionEvent(applicationContext);
  }, []);

  return (
    <>
      <Upsell
        header={
          <Box css={{ display: 'flex', alignItems: 'center', justifyContent: 'start', gap: 'sm' }}>
            <Heading level={2} textStyle="body-lg-bold">
              Reuse your application
            </Heading>
            <Tag size="sm" tone="info">
              FREE
            </Tag>
          </Box>
        }
        body={
          <Text>
            Apply to participating Zillow listings, or share via email with additional properties you find outside of
            Zillow.
          </Text>
        }
        media={
          <Icon size="lg">
            <IconChecklistFilled />
          </Icon>
        }
        action={<TextButton onClick={onClickShare}>Share application</TextButton>}
        closeable={false}
        elevated={false}
      />

      {isShareModalOpen && (
        <ApplicationShare
          onClose={() => {
            setIsShareModalOpen(false);
            router.push({ pathname: '/', query: queryWithoutShareAddress });
          }}
          userStatuses={userStatuses}
          initialAddress={typeof shareAddress === 'string' ? shareAddress : undefined}
          initialUnit={typeof unit === 'string' ? unit : undefined}
        />
      )}
    </>
  );
}
